import { APP_URLS } from "@neonumy/api-clients";
import { Card } from "@neonumy/neonumy-ui";
import { appsPermissions } from "hooks/Permissions/RequiredPermissions/general";
import { useHasPermission } from "hooks/Permissions/useCheckPermissions";
import { useTranslation } from "react-i18next";
import Coffre from "resources/images/coffre.svg?react";
import Fact from "resources/images/fact.svg?react";
import ScanPro from "resources/images/scan-pro.svg?react";
import Treso from "resources/images/treso.svg?react";

export default function Overview() {
  const { t } = useTranslation();
  const hasPermission = useHasPermission();

  const items = [
    {
      key: "scan-pro",
      label: t("Scan a Document"),
      Icon: ScanPro,
      href: APP_URLS.neoProUrl,
      permission: appsPermissions.neoScanPro,
    },
    {
      key: "treso",
      label: t("Manage Transactions"),
      Icon: Treso,
      href: APP_URLS.neoTresoUrl,
      permission: appsPermissions.neoTreso,
    },
    {
      key: "fact",
      label: t("Create an Invoice"),
      Icon: Fact,
      href: APP_URLS.neoFactUrl,
      permission: appsPermissions.neoFact,
    },
    {
      key: "coffre",
      label: t("Manage your Files"),
      Icon: Coffre,
      href: APP_URLS.neoCoffreUrl,
      permission: appsPermissions.neoCoffre,
    },
  ].filter(item => hasPermission(item.permission));

  if (!items.length) return null;

  return (
    <Card borderRadius={20} className="overview-card">
      <div className="overview-panel">
        {items.map(({ key, label, Icon, href }) => (
          <a
            key={key}
            className="overview-panel__item"
            href={href}
            target="_blank"
            rel="noreferrer"
          >
            <Icon />
            <span>{label}</span>
          </a>
        ))}
      </div>
    </Card>
  );
}
